import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const IpRegistrationTutorials: React.FC = () => {
  return (
    <Box sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h5" gutterBottom>
        Tutoriais de Registro de Propriedade Intelectual
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight="bold">Como registrar uma Marca</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" paragraph>
            Para registrar uma marca, você deve criar um arquivo digital (como um PDF ou imagem) que contenha a representação visual da marca, seu nome, logotipo e uma breve descrição dos produtos ou serviços que ela representa.
          </Typography>
          <Typography variant="body2" paragraph>
            Após criar o arquivo, faça o upload dele nesta plataforma para gerar o hash SHA-256. Este hash será gravado na blockchain, servindo como prova imutável de anterioridade da sua marca.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight="bold">Como registrar um Software (Código-Fonte)</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" paragraph>
            O registro de software requer que você compacte o código-fonte final (por exemplo, em um arquivo .zip ou .tar.gz). Recomenda-se incluir um arquivo de texto com a descrição do software, versão, autores e as tecnologias utilizadas.
          </Typography>
          <Typography variant="body2" paragraph>
            Em seguida, faça o upload desse arquivo compactado para gerar o hash. O registro na blockchain comprova que aquele código existia naquela exata versão, na data do registro.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight="bold">Como registrar uma Patente/Invento</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" paragraph>
            Para proteger um invento antes mesmo do depósito no órgão oficial (como o INPI), crie um documento detalhado descrevendo o invento, suas reivindicações, desenhos técnicos e o problema que ele resolve.
          </Typography>
          <Typography variant="body2" paragraph>
            O registro do hash deste documento garante uma prova técnica de anterioridade, que pode ser crucial para provar a autoria da invenção em disputas legais.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight="bold">Como proteger os arquivos originais</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" paragraph>
            A blockchain armazena apenas o hash (a impressão digital) do seu arquivo, e não o arquivo em si. Portanto, a proteção do arquivo original é de sua inteira responsabilidade.
          </Typography>
          <Typography variant="body2" component="ul" sx={{ pl: 2 }}>
            <li><strong>Armazenamento Seguro:</strong> Guarde os arquivos originais que geraram os hashes em locais seguros (múltiplos backups físicos e em nuvem).</li>
            <li><strong>Não modifique o arquivo:</strong> Qualquer alteração no arquivo, por menor que seja (como mudar um ponto ou renomear), resultará em um hash completamente diferente.</li>
            <li><strong>Versões:</strong> Se você atualizar sua marca ou software, gere um novo arquivo e registre um novo hash para essa versão.</li>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default IpRegistrationTutorials;
